/* Il video della prima schermata, per chi non lo vuole in movimento.
 *
 * "Riduci le animazioni" e' una richiesta del sistema operativo, non del sito,
 * e il CSS non puo' fermare un video: autoplay e' un attributo, non una
 * proprieta' di stile. Qui l'attributo viene tolto e il video messo in pausa
 * sul primo fotogramma, che e' la locandina - quindi chi ha quella
 * preferenza vede l'immagine ferma e nient'altro cambia.
 *
 * Si ascolta anche il cambio della preferenza a pagina aperta: chi la attiva
 * mentre sta guardando non deve ricaricare per essere ascoltato.
 */
(function () {
  'use strict';

  var query = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  if (!query) return;

  function apply() {
    var videos = document.querySelectorAll('.radar-hero__video');
    for (var i = 0; i < videos.length; i += 1) {
      var video = videos[i];
      if (query.matches) {
        video.removeAttribute('autoplay');
        video.pause();
        // Torna al primo fotogramma, che e' l'immagine della locandina: fermarsi
        // a meta' clip lascerebbe un fermo immagine qualunque.
        try { video.currentTime = 0; } catch (error) { /* non ancora pronto: pazienza */ }
      } else if (video.paused) {
        var started = video.play();
        // play() rifiuta la promessa quando il browser blocca comunque
        // l'autoplay: non e' un errore da segnalare, il video resta fermo sulla
        // locandina ed e' esattamente il ripiego giusto.
        if (started && started.catch) started.catch(function () {});
      }
    }
  }

  apply();
  if (query.addEventListener) query.addEventListener('change', apply);
  else if (query.addListener) query.addListener(apply);
})();
